(function () {
  function initAutoplay(root = document) {
    const items = root.querySelectorAll('deferred-media[data-media-id], product-model[data-media-id]');
    if (!items.length) return;

    // Load deferred content when mostly in view
    const io = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const el = entry.target;
        if (!entry.isIntersecting || entry.intersectionRatio < 0.6) return;

        // If it's a standard deferred-media with a poster/button, click to load the <template> content
        const posterBtn = el.querySelector('.deferred-media__poster');
        if (posterBtn && !el.__loaded) {
          posterBtn.click();
          el.__loaded = true;
        }

        // After it loads, try to play the video if present
        setTimeout(() => {
          const video = el.querySelector('video');
          if (video) {
            try {
              video.muted = true;
              video.setAttribute('playsinline', '');
              video.play().catch(() => {});
            } catch (e) {}
          }

          // For iframes (YouTube/Vimeo), autoplay is requested via URL params already.
          // If the host ignores without gesture, it will start once user interacts.
        }, 80);
      });
    }, { threshold: [0.0, 0.6, 1.0] });

    items.forEach((el) => io.observe(el));

    // Pause videos when slide changes in Dawn sliders
    const galleries = root.querySelectorAll('media-gallery, slider-component, .product__media-list');
    const pauseOthers = (activeEl) => {
      root.querySelectorAll('video').forEach((v) => {
        if (!activeEl || !activeEl.contains(v)) v.pause();
      });
    };

    galleries.forEach((g) => {
      g.addEventListener('slideChanged', () => {
        // Find the visible slide and prioritize its video
        const active = g.querySelector('[aria-hidden="false"], .is-selected') || g;
        const v = active.querySelector('video');
        if (v) {
          try { v.muted = true; v.setAttribute('playsinline', ''); v.play().catch(() => {}); } catch (e) {}
        }
        pauseOthers(active);
      });
    });

    // Also react to thumbnail clicks or prev/next
    root.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-thumbnail], button[name="previous"], button[name="next"]');
      if (!btn) return;
      setTimeout(() => {
        const active = root.querySelector('[aria-hidden="false"], .is-selected') || root;
        const v = active.querySelector('video');
        if (v) { try { v.muted = true; v.setAttribute('playsinline',''); v.play().catch(()=>{}); } catch(e){} }
        pauseOthers(active);
      }, 60);
    });
  }

  document.addEventListener('DOMContentLoaded', () => initAutoplay(document));
  document.addEventListener('shopify:section:load', (evt) => initAutoplay(evt.target));
})();
